var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    xmlnsv: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.055c0-1.731-.493-3.425-1.421-4.882s-2.25-2.617-3.812-3.341A8.95 8.95 0 0 0 7.766.086c-1.704.237-3.304.961-4.612 2.085A9.06 9.06 0 0 0 .387 6.428a9.11 9.11 0 0 0-.049 5.087c.467 1.665 1.399 3.161 2.685 4.311S5.895 17.73 7.594 18v-6.328H5.309V9.055h2.285V7.059c0-2.269 1.344-3.523 3.399-3.523.675.01 1.349.069 2.015.177v2.229h-1.135c-.342-.046-.688.047-.962.258a1.31 1.31 0 0 0-.499.866 1.3 1.3 0 0 0-.006.291v1.698H12.9l-.399 2.618h-2.1V18c2.118-.336 4.047-1.422 5.441-3.062A9.09 9.09 0 0 0 18 9.055z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.81ac1f19f8b4310e6cba733d415d9a00.svg";
export { ForwardRef as ReactComponent };